var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bestaetigung"},[_c('Header'),_c('Hero',{attrs:{"step":"bestaetigung"}}),_c('Status_Success'),_c('TicketDownload'),_c('Footer'),_c('SlideNavigation',{attrs:{"prev-route":"daten","next-route":"tickets"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }